import * as z from "zod";

export const generateWorkOrderGenerationReport = {
  name: "generateWorkOrderGenerationReport" as const,
  input: z.object({}),
  output: z.object({ csv: z.string() }),
};
